import { MinioAPI } from "@/api/minio.api";
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';

const BUCKET_NJI_DAE = 'nji-dae'
const FOLDER_NJI_DAE = ''

const BUCKET_NJI_NOTIFICACAO_PENALIDADE = 'nji-notificacao-penalidade'
const FOLDER_NJI_NOTIFICACAO_PENALIDADE = ''

const BUCKET_NJI_RELATORIO_JULGAMENTO = 'nji-relatorio-julgamento'
const FOLDER_NJI_RELATORIO_JULGAMENTO = ''

export interface MinioModel {
  file: string;
  folder: string;
  bucketName: string;
  recaptcha: string;
}

const api = new MinioAPI()

const downloadNjiDae = (file: string, recaptcha: string): AxiosObservable<any> => api.download({
  bucketName: BUCKET_NJI_DAE,
  folder: FOLDER_NJI_DAE,
  file: file + ".pdf",
  recaptcha
})

const downloadNjiNotificacaoPenalidade = (file: string, recaptcha: string): AxiosObservable<any> => api.download({
  bucketName: BUCKET_NJI_NOTIFICACAO_PENALIDADE,
  folder: `${FOLDER_NJI_NOTIFICACAO_PENALIDADE}${file.split("/")[1]}`,
  file: file.replace("/", "-") + ".pdf",
  recaptcha
})

const downloadNjiNotificacaoPenalidade2024 = (file: string, recaptcha: string): AxiosObservable<any> => api.download({
  bucketName: BUCKET_NJI_NOTIFICACAO_PENALIDADE,
  folder: `${FOLDER_NJI_NOTIFICACAO_PENALIDADE}${file.split("/")[1].split("-")[0]}`,
  file: file.replace("/", "-") + ".pdf",
  recaptcha
})

const downloadNjiRelatorioJulgamento = (file: string, recaptcha: string): AxiosObservable<any> => api.download({
  bucketName: BUCKET_NJI_RELATORIO_JULGAMENTO,
  folder: `${FOLDER_NJI_RELATORIO_JULGAMENTO}${file.split("/")[1]}`,
  file: file.replace("/", "-") + ".pdf",
  recaptcha
})
const downloadNjiRelatorioJulgamento2024 = (file: string, recaptcha: string): AxiosObservable<any> => api.download({
  bucketName: BUCKET_NJI_RELATORIO_JULGAMENTO,
  folder: `${FOLDER_NJI_RELATORIO_JULGAMENTO}${file.split("/")[1].split("-")[0]}`,
  file: file.replace("/", "-") + ".pdf",
  recaptcha
})

export default {
  downloadNjiDae,
  downloadNjiNotificacaoPenalidade,
  downloadNjiRelatorioJulgamento,
  downloadNjiNotificacaoPenalidade2024,
  downloadNjiRelatorioJulgamento2024
}
